import { useQuery } from "@tanstack/react-query";
import { sendAjaxRequest } from "@/ts/api/comunicacion";

export function useFamilias() {
	return useQuery<Familia[]>({
		queryKey: ["getFamilias"],
		queryFn: () => {
			return sendAjaxRequest<Familia[]>("GET", "/api/v1/getFamilias");
		}
	});
}
export interface Familia {
	idFamilia: string,
	nombreFamilia: string;
}

export function useSubFamilias() {
	return useQuery<Subfamilia[]>({
		queryKey: ["getSubfamilias"],
		queryFn: () => {
			return sendAjaxRequest<Subfamilia[]>("GET", "/api/v1/getSubfamilias");
		}
	});
}
export interface Subfamilia {
	idSubFamilia: string,
	nombreSubFamilia: string;
}
